module.exports = __webpack_public_path__ + "static/media/test-my-stress-logo-new.dc20e61d.svg";